export const FIELD_INFO = {
    name: {
        minLength: 1,
        maxLength: 255,
    },
    description: {
        minLength: 1,
        maxLength: 5000,
    },
    optionName: {
        maxLength: 255,
    },
    maxImages: 250,
    maxImagesLevel: 'product',
} as const
